import { ModuleWithProviders, NgModule } from '@angular/core';
import { PendoService } from './shared/pendo.service';

export interface PendoConfiguration {
  enabled: boolean;
  pendoId: string;

  whitelist?: {
    [environmentApplication: string]: string[];
  };

  idPrefixes?: {
    // Prefix users in different environments with strings, e.g. dev-123, stag-123
    [environmentDeploy: string]: string;
  };
}

@NgModule({
  imports: [],
})
export class PendoModule {
  constructor() {}

  static forRoot(config: PendoConfiguration): ModuleWithProviders<PendoModule> {
    return {
      ngModule: PendoModule,
      providers: [PendoService, { provide: 'pendoConfig', useValue: config }],
    };
  }
}
